import { Outlet } from "react-router";
import Header from "../../../component/layout/header";
import useNav from "../../../script/tabingNavArray";

const OrganizationProjectsLayout = () => {
  const navList = useNav();
  let { orgprojectBottomNav, topProjectNav } = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={orgprojectBottomNav} topTabs={topProjectNav} />
      <Outlet />
    </div>
  );
};

export default OrganizationProjectsLayout;
